module.exports = __webpack_public_path__ + "media/images/flags/4x3/lso-04f822b0c7521e1ef475cd74560e1b83.svg";